<template>
<div class="hello">
    <Menu></Menu>
    <div class="class">
        <!-- <div class="page-top-wrap"> -->
        <div class="top wrap clear">
            <h2 class="bold  float-left">Untact 수업 환경 문의</h2><br>
        </div>
        <!-- </div> -->

        <div class="page-top-wrap-notice">
            <div class="notice-wrap">
                <div class="add-box clear">
                    <div class="float-left w-25per txt-left reason-box-title">Class</div>
                    <div class="float-left w-75per pr-20">
                        <select v-model="info.classid">
                            <option value="0">수강 중인 Class를 선택해 주세요.</option>
                            <option v-for="(item,index) in classlist" :key="index" :value="item.classid">{{item.classname}}</option>
                        </select>
                    </div>

                </div>
                <div class="add-box clear">
                    <div class="float-left w-25per txt-left reason-box-title">E-mail</div>
                    <div class="float-left w-75per pr-20">
                        <input type="text" v-model="member.email" />
                    </div>
                </div>
                <div class="add-box clear">
                    <div class="float-left w-25per txt-left reason-box-title">제목</div>
                    <div class="float-left w-75per pr-20">
                        <input type="text" placeholder="제목을 입력해 주세요." v-model="info.title" />
                        <img src="../assets/img/file-icon.png" class="file" @click="fileCLick()" />
                        <input type="file" id="upfile" name="upfile" style="display:none" @change="FileChange($event)" accept=".jpg, .png, .doc, .docx, .hwp, .pdf, .ppt, .pptx" />
                    </div>
                    
                </div>
                <div class="add-box" v-if="info.upfile!=''">
                    <a href="#"><img src="../assets/img/file-download.png" class="mr-10 down-img" />{{info.upfile}}<span @click="doDelete()" style="color :red; cursor:pointer" class="ml-20">x</span></a>
                </div>
                <div class="add-box">
                    <textarea placeholder="내용을 입력해 주세요" v-model="info.contents"></textarea>
                </div>
            </div>
        </div>
        <div class="pt-20 btn">
            <button class="btn-base-white float-left" @click="cancel()">취소</button>
            <button class="btn-base float-right" @click="doSubmit()">문의하기</button>
        </div>

    </div>

    <!-- 푸터 -->
    <div class="footer clear">
        Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
    </div>
</div>
</template>

<script>
import Menu from '../components/inc_menu.vue'
export default {
    name: 'UntactAdd',
    components: {
        Menu
    },
    props: {
        msg: String
    },
    data: () => ({
        classlist: [],
        member: "",
        info: {
            classid: "0",
            title: "",
            contents: "",
            upfile: ""
        }
    }),
    created() {
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.$store.commit("loginCheck");
    },
    mounted() {
        //    this.doc_del_rendar();
        this.getMember();
        this.getClassList();
    },
    methods: {
        doDelete() {
            if (confirm("파일을 삭제하시겠습니까?") == true) {

                var me = this;
                me.info.upfile = "";
                document.getElementById("upfile").value = "";
                // me.info.is_update[index] = true;
                console.log(me.info);
            }
        },
        fileCLick() {
            var file = document.getElementById("upfile");
            file.click();
        },
        cancel() {
            location.href = "/untacttest"
        },
        FileChange() {
            var fileext = event.target.files[0].name.slice(event.target.files[0].name.indexOf(".") + 1).toLowerCase();
            // console.log(fileext);
            var mexSize = 2 * 1024 * 1024
            if(event.target.files[0].size > mexSize){
                alert("첨부파일 사이즈는 2MB 이내로 등록 가능합니다.");
                return false;
            }else{
                if(fileext == 'jpg' || fileext == 'png' || fileext=='word' || fileext == 'hwp' || fileext == 'pdf' || fileext == 'ppt' || fileext == 'pptx'){
                    this.reasonFile1 = event.target.files[0].name;
                }else{
                    alert("파일첨부는 jpg, png, word, hwp, pdf, ppt 만 가능합니다.");
                    return false;
                }
            }
        },
        getClassList() {
            var me = this;
            var params = {
                uidx: localStorage.getItem("uidx"),
                lesson_state: "2"
            }
            this.axios.get(this.$store.state.host + "/rest/mobile/classlist_untact_new", {
                params: params
            }).then(function (res) {
                if (res.data.err == 0) {
                    me.classlist = res.data.classes;
                    // if(me.classlist.length == 1){
                    me.info.classid = me.classlist[0].classid;
                    // }
                    console.log(me.classlist);
                } else {
                    alert(res.data.err_msg);
                }
            });
        },
        getMember() {
            var params = {
                uidx: localStorage.getItem("uidx"),
                accessKey: localStorage.getItem("accessKey")
            };
            var me = this;
            this.axios.get(this.$store.state.host + '/rest/mobile/getMember', {
                params: params
            }).then(function (res) {
                // console.log(res.data.member);
                me.member = res.data.member;

                if (me.member.email == "") {
                    me.member.email = me.member.uid;
                }
            });

        },
        doSubmit() {
            var me = this;
            if (me.info.classid == 0) {
                alert("수강중인 class를 선택해주세요.");
                return false;
            }
            if (me.info.title == "") {
                alert("제목을 입력해주세요.");
                return false;
            }
            if (me.info.contents == "") {
                alert("내용을 입력해주세요.");
                return false;
            }
            if (confirm("입력하신 내용으로 문의하시겠습니까?") == true) {
                var formData = new FormData();
                formData.append("idx_member", localStorage.getItem("uidx"));
                formData.append("email", me.member.email);
                formData.append("classid", me.info.classid);
                formData.append("title", me.info.title);
                formData.append("contents", me.info.contents);
                formData.append("upfile", document.getElementById("upfile").files[0]);

                this.axios.post(this.$store.state.host + "/rest/mobile/untact_question_add", formData).then(function (res) {
                    if (res.data.err == 0) {
                        alert("문의 사항이 등록 되었습니다.");
                        location.href = "/untacttest";
                    } else {
                        alert(res.data.err_msg);
                    }
                });
            }
        }
    }
    //   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.class {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 60px;

    .floating-write {
        position: fixed;
        right: 0;
        cursor: pointer;
        bottom: 0;
    }

    // .page-top-wrap {
    //     width: 100%;
    //     border-bottom: 10px solid #F5F5F5;

    .top {
        // padding-right: 20px;
        border-bottom: 10px solid #f5f5f5;;
        padding-bottom: 17px;
        padding-top: 70px;
        background: url("../assets/img/top-bg.png") no-repeat right -80px;
        background-size: 300px;
        position: relative;

        .my-reason {
            position: absolute;
            right: 0;
            bottom: 15%;
        }

        p {
            font-size: 14px;
            letter-spacing: 0px;
            color: #000000;
            opacity: 1;
            margin-top: 20px;
        }

        div {
            select {
                border: 1px solid var(--unnamed-color-53caff);
                background: #FFFFFF 0% 0% no-repeat padding-box;
                border: 1px solid #53CAFF;
                border-radius: 4px;
                opacity: 1;
                color: #53CAFF;
                ;
            }
        }
    }

    .wrap {
        width: 100%;
        max-width: 700px;
    }

    // }

    .page-top {
        border-bottom: 1px solid #E9E9E9;

        .review-top {

            div {
                background: #F5F5F5 0% 0% no-repeat padding-box;
                border: 1px solid #E9E9E9;
                border-radius: 10px;
                opacity: 1;
                width: 95%;
                margin: 0 auto;
                box-sizing: border-box;
                padding-top: 19px;
                padding-bottom: 19px;

                p {
                    float: left;
                    text-align: center;

                    &:first-child {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #B7B7B7;
                        opacity: 1;
                    }

                    &:last-child {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #000000;
                        opacity: 1;
                    }
                }
            }
        }
    }

    .page-top-wrap-notice {
        width: 90%;
        max-width: 700px;
        padding-bottom: 20px;
        margin: 0 auto;

        .none-notice {
            display: table;
            min-height: 300px;
            width: 100%;

            p {
                display: table-cell;
                vertical-align: middle;
                text-align: center;
                color: var(--unnamed-color-b7b7b7);
                text-align: center;
                font-size: 16px;
                font-weight: bold;
                letter-spacing: 0px;
                color: #B7B7B7;
                opacity: 1;
            }
        }

        .notice-wrap {
            .add-box {
                width: 100%;
                border-bottom: 1px solid #E9E9E9;
                padding-top: 15px;
                padding-bottom: 15px;
                padding-left: 20px;
                padding-right: 20px;
                position: relative;

                select {
                    width: 100%;
                    border: none;
                    font-size: 14px;
                    letter-spacing: 0px;
                    color: #000000;
                    background: white;
                    opacity: 1;
                }

                input[type="text"],
                input[type="password"] {
                    border-radius: 0;
                    border-top: none;
                    border-right: none;
                    border-left: none;
                    border-bottom: none;
                    font-size: 16px;
                    padding: 0 10px;
                    width: 100%;
                }

                .file {
                    position: absolute;
                    right: 0;
                    right: 20px;
                    width: 20px;
                    cursor: pointer;
                }

                a {
                    font-size: 14px;
                    letter-spacing: 0px;
                    color: #53CAFF;
                    opacity: 1;
                }

                textarea {
                    width: 100%;
                    border: none;
                    height: 200px;
                    resize: none;
                    font-size: 16px;
                }
                img{
                    width: 25px;
                }
                img.down-img{
                    width: 14px;
                }
            }
        }
    }
}

.btn {
    width: 100%;
    max-width: 700px;
    margin: 0 auto;
}

.footer {
    position: static;
}

@media only screen and (max-width: 414px) {
    .class {
        width: 100%;

        .top {
            background: url("../assets/img/top-bg.png") no-repeat 160px -80px;
            background-size: 300px;

            &.wrap {
                width: 100%;
                padding-left: 5%;
                max-width: none;
            }
        }

        .page-top-wrap-notice {
            width: 100%;

            .wrap {
                width: 90%;
                max-width: none;
            }
        }
    }

    .btn {
        width: 90%;
    }
}
</style>
